import { useState } from "react";
import { Mail, X } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const KEY = "vts_email_optin_v1";

const EmailOptIn = ({ accountId = "", source = "arcade" }) => {
  const [hidden, setHidden] = useState(() => { try { return !!localStorage.getItem(KEY); } catch { return false; } });
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  if (hidden) return null;
  const submit = async () => {
    const e = email.trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e)) { toast.error("Enter a valid email"); return; }
    setBusy(true);
    try {
      await api.post("/marketing/email", { email: e, source, account_id: accountId || "" });
      try { localStorage.setItem(KEY, e); } catch { /* noop */ }
      setHidden(true);
      toast.success("📧 You're in — tips, new games and updates coming your way");
    } catch {
      toast.error("Could not save — try again in a moment");
    } finally { setBusy(false); }
  };
  return (
    <div data-testid="email-optin-card" className="rounded-xl border border-[#53b9ff]/30 bg-[#53b9ff]/5 p-3">
      <div className="flex items-center gap-2">
        <Mail className="w-4 h-4 text-[#53b9ff]" />
        <p className="text-[11px] font-mono font-black text-white/80 flex-1">Get VTS tips, new games &amp; feature drops by email</p>
        <button data-testid="email-optin-dismiss" onClick={() => { setHidden(true); try { localStorage.setItem(KEY, "dismissed"); } catch { /* noop */ } }}
          className="p-1 rounded hover:bg-white/10"><X className="w-3.5 h-3.5 text-white/40" /></button>
      </div>
      <div className="mt-2 flex gap-2">
        <input data-testid="email-optin-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com" onKeyDown={(e) => e.key === "Enter" && submit()}
          className="flex-1 h-9 rounded-lg border border-white/15 bg-[#0d1117] px-3 text-xs font-mono text-white placeholder:text-white/25 focus:border-[#53b9ff]/60 outline-none" />
        <button data-testid="email-optin-submit" disabled={busy} onClick={submit}
          className="px-4 h-9 rounded-lg bg-[#53b9ff] text-black text-[11px] font-black font-mono disabled:opacity-40 hover:bg-[#7cc9ff] transition-colors">JOIN</button>
      </div>
      <p className="mt-1 text-[8.5px] font-mono text-white/30">no spam — unsubscribe anytime, email never shown publicly</p>
    </div>
  );
};

export default EmailOptIn;
